import { render } from "./GoalInput.vue?vue&type=template&id=5d51bece&scoped=true"
import script from "./GoalInput.vue?vue&type=script&lang=js"
export * from "./GoalInput.vue?vue&type=script&lang=js"

import "./GoalInput.vue?vue&type=style&index=0&id=5d51bece&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d51bece"]])

export default __exports__